import { render, staticRenderFns } from "./FilterDocumentShow.vue?vue&type=template&id=2dcfda1d&scoped=true"
import script from "./FilterDocumentShow.vue?vue&type=script&lang=js"
export * from "./FilterDocumentShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfda1d",
  null
  
)

export default component.exports